import { render, staticRenderFns } from "./AdminDelegating.vue?vue&type=template&id=36650f6a&scoped=true&"
import script from "./AdminDelegating.vue?vue&type=script&lang=js&"
export * from "./AdminDelegating.vue?vue&type=script&lang=js&"
import style0 from "./AdminDelegating.vue?vue&type=style&index=0&id=36650f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36650f6a",
  null
  
)

export default component.exports